<ng-template #table>
  <!-- <div style="font-size: 12px;font-weight: bold;">Other Charges</div> -->
  @for (service_charge of data.info; track service_charge) {
    <div style="color: #535665;font-size: 12px;font-weight: 500;margin: 16px 0">
      <div style="display: flex;justify-content: space-between;margin-bottom: 6px;">
        <div>{{ service_charge.name }}</div>
        @if (!data.isCreditsUsed) {
          <div>{{ service_charge.amount | rupee }}</div>
        }
        @if (data.isCreditsUsed) {
          <div>{{ service_charge.amount_with_credit | rupee }}</div>
        }
      </div>
      @if (service_charge.message) {
        <div style="color: #707373;font-size: 10px;">{{ service_charge.message }}</div>
      }
    </div>
  }
</ng-template>

<!-- <ng-template #info>
<div>{{ data.info }}</div>
</ng-template>

<div style="width: 50vw;margin-bottom: 8px;">
  <ng-container *ngIf="data.type === 'tabularView'; else info">
    <ng-container *ngTemplateOutlet="table"></ng-container>
  </ng-container>
  <div class="pointer"></div>
  <div style="position: absolute;
  bottom: 0;
  width: 25px;
  height: 16px;
  background: #fff;
  z-index: 2;"></div>
</div> -->

<div style="margin: 6px 0;">
  <span style="font-size: 16px;font-weight: 600;">{{ data.type }}</span>
  <div class="pull-right close" (click)="close()"> &#10005; </div>
</div>

<mat-dialog-content class="info-dialog-content">
  <ng-container>
    <ng-container *ngTemplateOutlet="table"></ng-container>
  </ng-container>
</mat-dialog-content>
